import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class OiVesselListItem extends SearchModelBase {
    vessel: string = '';
    voyage: string = '';
    discharge: string = '';
    eta: string | null = null;
    fromEta: string | null = null;
    toEta: string | null = null;
    id: number = 0;

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true, filterable: false }),
        XCol.Create({ col: 1, text: 'Vessel Name', width: 150, dataIndex: 'vessel', defaultColumnFocus : true}),
        XCol.Create({ col: 2, text: 'Voyage #', width: 80, dataIndex: 'voyage'}),
        XCol.Create({ col: 3, text: 'Discharge Port', width: 150, dataIndex: 'discharge'}),
        XCol.Create({ col: 4, text: 'ETA', width: 75, dataIndex: 'eta', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
    ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: OiVesselListItem.prototype.id, orderByAscending: false };

    public static formatData(data: OiVesselListItem[]) {
        return data.map((d: OiVesselListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        eta: {from: 'fromEta', to: 'toEta'},
    };
}
